import { RemoteUpdateProfessionalManagement } from 'data/usecases/professionals';
import { UpdateProfessionalManagementUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfessionalsManager } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdateProfessionalManagement =
  (): UpdateProfessionalManagementUseCaseInterface =>
    new RemoteUpdateProfessionalManagement(
      makeApiUrlProfessionalsManager(),
      makeAxiosHttpClient(),
    );
